import * as React from 'react';
import styles from './index.less';
import img_yubi from '@/pages/activity/$id/Contest202409/yubi@2x.png';
import { Modal } from 'antd';
import { FI18n } from '@freelog/tools-lib';
import FSimpleBar from '@/components/FSimpleBar';

interface RuleModalProps {
  open: boolean;

  onCancel?(): void;
}

function RuleModal({ open, onCancel }: RuleModalProps) {
  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      // closable={false}
      width={1000}
      centered={true}
      style={{ borderRadius: 10, overflow: 'hidden' }}
      // bodyStyle={{ height: 'calc(100vh - 200px)', padding: 0 }}
      onCancel={onCancel}
      styles={{ content: { padding: 0 } }}
    >
      <FSimpleBar height={'calc(100vh - 200px)'}>
        <div className={styles.ruleModalBody}>
          <div className={styles.ruleModalContent}>
            <div style={{ height: 40 }} />
            <div className={styles.h1}>活动规则</div>
            <div className={styles.h2}>一、活动时间</div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>1</div>
              {/*<span>活动期限：本期活动征集截止至2025-3-16 23:59:59，活动评选期为2025-03-17 00:00:00～ 2025-03-31 23:59:59，活动结果将于2025-04-16 15:00:00公示；</span>*/}
              {/*FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_selection_date').replaceAll('<br>', '')*/}
              <span>
                活动期限：本期活动征集截止至
                {FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_collect_date2')}，活动评选期为
                {`${FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_selection_date_start')} ~ ${FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_selection_date_end')}`}
                ，活动结果将于{FI18n.i18nNext.tAuto('event_2024monthlyeditorspick_awards_date')}公示；
              </span>
            </div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>2</div>
              <span>
                活动奖励将在结果公示期结束后，即在官方公布最终获奖名单后的15个工作日内，发放至获奖用户的Freelog账号名下；
              </span>
            </div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>3</div>
              <span>参与建议：为保证您的活动参与体验，请尽量使用电脑PC端访问freelog网页版。</span>
            </div>

            <div className={styles.h2}>二、活动参与要求</div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>1</div>
              <span>
                请勿上传空白文件、无实质内容的资源，以及其他任何形式的虚假或无意义资源。一经发现，相关资源将无法参与活动评选。
              </span>
            </div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>2</div>
              <span>
                参与本次活动的资源和展品必须在活动结算之前保持上架状态，否则，可能会影响活动评选及奖励的发放。
              </span>
            </div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>3</div>
              <div>活动资源原创性与版权规则：</div>
              <div className={styles.content} style={{ paddingLeft: 14 }}>
                <div className={styles.ls}>
                  <i />
                </div>
                <div>
                  用户发布的资源必须为原创作品，禁止抄袭、搬运、代投、恶意二改（即未经授权对他人作品进行修改，尤其是以损害原作品完整性或原始意图的方式）他人内容等，此外，本次活动不接受任何形式的人工智能（AI）生成的作品；
                </div>
              </div>
              <div className={styles.content} style={{ paddingLeft: 14 }}>
                <div className={styles.ls}>
                  <i />
                </div>
                <div>
                  对于合作创作的资源，参与各方应协商一致，通过一个指定的特定账号进行发布。严禁多人使用各自账号重复发布相同或相似的合作资源；
                </div>
              </div>
              <div className={styles.content} style={{ paddingLeft: 14 }}>
                <div className={styles.ls}>
                  <i />
                </div>
                <div>
                  用户需确保对发布的资源拥有完整的著作权或已获得必要的授权，若因未获得授权或侵犯他人版权导致任何法律纠纷，Freelog平台不承担任何法律责任。相关责任由侵权用户自行承担；
                </div>
              </div>
              <div className={styles.content} style={{ paddingLeft: 14 }}>
                <div className={styles.ls}>
                  <i />
                </div>
                <div>一经发现用户有违反上述原创性与版权规则的，其相关资源将无法参与活动评选。</div>
              </div>
            </div>

            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>4</div>
              <span>
                所有用户须遵守
                <a
                  target={'_blank'}
                  href={
                    'https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2'
                  }
                >
                  《Freelog平台管理规范》
                </a>
                ，一经发现用户存在违反平台管理规范的行为，其相关资源将无法参与活动评选。
              </span>
            </div>

            <div className={styles.h2}>三、活动常见Q&A：</div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>1</div>
              <div>如何提交产品使用反馈</div>
              <div className={styles.content}>
                <span>
                  用户可以Freelog【社区】的{' '}
                  <a target={'_blank'} href={'https://forum.freelog.cn/category/3'}>
                    吐槽反馈区
                  </a>{' '}
                  ，在该模块内发帖提交您的使用反馈和建议，Freelog工作人员会查看解答大家的反馈哦~{' '}
                </span>
              </div>
            </div>
            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>2</div>
              <div>如何在授权合约流程中使用真实货币交易</div>
              <div className={styles.content}>
                <span>
                  内测期间，Freelog暂不支持真实货币交易，为了便于用户体验资源授权合约交易中的付费相关功能，Freelog提供虚拟币
                  <strong>“羽币”</strong>支持。
                </span>
              </div>
              <div className={styles.content}>
                <span>
                  内测期间，羽币与真实货币无任何联系，Freelog平台不支持以任何形式、任何比例进行羽币与真实货币之间的兑换。
                </span>
              </div>
            </div>

            <div className={styles.h3} style={{ paddingLeft: 30 }}>
              <div className={styles.number}>3</div>
              <div>如何领取羽币</div>
              <div className={styles.content}>
                <div>
                  用户可以通过点击【个人中心】—【我的钱包】进入“羽币账户”界面，先点击激活您的羽币账户后，点击下方【立即领取】按钮即可领取100枚内测羽币。
                </div>
                <div style={{ height: 20 }} />
                <img src={img_yubi} alt={''} style={{ width: '100%', display: 'block' }} />
                <div style={{ height: 20 }} />
                <div>
                  更多活动问题答疑详见{' '}
                  <a
                    target={'_blank'}
                    href={
                      'https://freelog3.freelog.cn/home_freelog-query_id=62d0d04f456ff0002e329537'
                    }
                  >
                    常见问题
                  </a>
                </div>
              </div>
            </div>

            <div className={styles.h2}>四、遵守规范</div>
            <div className={styles.content}>
              所有用户须遵守
              <a
                target={'_blank'}
                href={
                  'https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2'
                }
              >
                《Freelog平台管理规范》
              </a>
              ，一经发现用户存在违反平台管理规范的行为，其相关资源将无法参与活动评选。
            </div>

            <div className={styles.h2}>五、违规举报</div>
            <div className={styles.content}>
              活动期间开放举报通道，用户可以通过联系官方工作人员或向Freelog发送邮件（service@freelog.com）对涉嫌违规的行为和用户进行举报。
              举报邮件内容需包含被举报作品名称、作品链接、涉嫌违规原因，否则不予处理；
            </div>

            <div className={styles.h2}>六、平台声明</div>
            <div className={styles.content}>
              活动最终解释权归Freelog所有，如有疑问请联系官方工作人员或发送邮件至官方邮箱
              service@freelog.com
            </div>

            <div style={{ height: 100 }} />
          </div>
        </div>
      </FSimpleBar>
    </Modal>
  );
}

export default RuleModal;
